/* Copyright 2019 VMware, Inc. All rights reserved. -- VMware Confidential */

module platform {

   import IInjectorService = angular.auto.IInjectorService;

   /**
    * Wrapper over downgraded service \vim-clients\applications\h5\ng-next-app\src\app\platform\services\managed-types-util\managed-types-util.service.ts
    */
   export class ManagedTypesUtilWrapper {
      static $inject = ["$injector"];
      private _vcManagedTypesUtil: any;

      constructor(private $injector: IInjectorService) {
      }

      get vcManagedTypesUtil(): any {
         if (!this._vcManagedTypesUtil) {
            this._vcManagedTypesUtil = this.$injector.get("vcManagedTypesUtil");
         }
         return this._vcManagedTypesUtil;
      }

      public deductTypeFromGlobalCisId(cisId?: string ): string|undefined {
         return this.vcManagedTypesUtil.deductTypeFromGlobalCisId(cisId);
      }
   }

   angular.module("com.vmware.platform.ui").service(
         "managedTypesUtil", ManagedTypesUtilWrapper);
}
